"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var classnames_1 = __importDefault(require("classnames"));
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var AudioMenu_less_1 = __importDefault(require("./AudioMenu.less"));
var AudioMenu = function (_a) {
    var className = _a.className, selectedAudioTrackId = _a.selectedAudioTrackId, audioTracks = _a.audioTracks, onAudioTrackSelected = _a.onAudioTrackSelected;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, common_1.useStorage)(), updateStorage = _b[1];
    var onAudioTrackClick = (0, react_1.useCallback)(function (_a) {
        var currentTarget = _a.currentTarget;
        var id = currentTarget.getAttribute('data-id');
        updateStorage({ audioTrackId: id });
        onAudioTrackSelected && onAudioTrackSelected(id);
    }, [onAudioTrackSelected]);
    var onMouseDown = function (event) {
        // @ts-expect-error: Property 'audioMenuClosePrevented' does not exist on type 'MouseEvent'.
        event.nativeEvent.audioMenuClosePrevented = true;
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(className, AudioMenu_less_1.default['audio-menu']), onMouseDown: onMouseDown },
        react_1.default.createElement("div", { className: AudioMenu_less_1.default['container'] },
            react_1.default.createElement("div", { className: AudioMenu_less_1.default['header'] }, t('AUDIO_TRACKS')),
            react_1.default.createElement("div", { className: AudioMenu_less_1.default['list'] }, audioTracks.map(function (_a, index) {
                var id = _a.id, label = _a.label, lang = _a.lang;
                return (react_1.default.createElement(components_1.Button, { key: index, title: label, className: (0, classnames_1.default)(AudioMenu_less_1.default['option'], { 'selected': selectedAudioTrackId === id }), "data-id": id, onClick: onAudioTrackClick },
                    react_1.default.createElement("div", { className: AudioMenu_less_1.default['info'] },
                        react_1.default.createElement("div", { className: AudioMenu_less_1.default['lang'] }, common_1.languages.label(lang)),
                        react_1.default.createElement("div", { className: AudioMenu_less_1.default['label'] }, label)),
                    selectedAudioTrackId === id ?
                        react_1.default.createElement("div", { className: AudioMenu_less_1.default['icon'] })
                        :
                            null));
            })))));
};
exports.default = AudioMenu;
